<template>

    <div class="homepage">
        <highlight-brands />
        <brands-banner />
        <highlight-products :products="products" />

        <div
            class="pagecontent"
            v-if="content.data.content && content.data.content !== ''"
        >
            <div class="container">
                <div v-html="content.data.content"></div>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import BrandsBanner from "../../components/Homepage/BrandsBanner.vue";
import HighlightBrands from "../../components/Homepage/HighlightBrands.vue";
import HighlightProducts from "../../components/Homepage/HighlightProducts.vue";

export default {

    components: {
        BrandsBanner,
        HighlightBrands,
        HighlightProducts,
    },

    layout:Layout,

    metaInfo() {
        return {
            title: this.content.data.name,
            meta: [
                { name: 'description', content: this.content.data.meta_description },
                { name: 'keywords', content: this.content.data.meta_keywords },
            ],
        }
    },

    name:'Homepage',

    props: {
        content: {
            required:true,
        },
        products: {
            required:true,
            type:Array,
        },
    },

}

</script>
